function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "icon-grid"
}, "Grid Icon-");

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 26,
  y: 26,
  width: 8,
  height: 8,
  rx: 1
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 36,
  y: 26,
  width: 8,
  height: 8,
  rx: 1
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 46,
  y: 26,
  width: 8,
  height: 8,
  rx: 1
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 26,
  y: 36,
  width: 8,
  height: 8,
  rx: 1
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 36,
  y: 36,
  width: 8,
  height: 8,
  rx: 1
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: 46,
  y: 36,
  width: 8,
  height: 8,
  rx: 1
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 26,
  y: 46,
  width: 8,
  height: 8,
  rx: 1
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 36,
  y: 46,
  width: 8,
  height: 8,
  rx: 1
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 46,
  y: 46,
  width: 8,
  height: 8,
  rx: 1
});

var SvgIconGrid = function SvgIconGrid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "aria-labelledby": "icon-grid",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "icon-grid"
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconGrid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-grid.6c66ef50.svg";
export { ForwardRef as ReactComponent };